import { createSlice } from "@reduxjs/toolkit";
import {
  fetchGuestUserFlow,
  fetchLogin,
  fetchLogout,
  fetchPostSignup,
  fetchSocialLogin,
} from "./apiThunk";
import {
  ToastNotifyError,
  ToastNotifySuccess,
} from "../../../components/CommonComponents/Toast/ToastNotify";

const initialData = {
  auth: {},
  userData: {},
  isLoading: false,
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: { ...initialData },
  reducers: {
    updateUserData: (state, action) => {
      state.userData = action.payload;
    },
    updateLogin: (state, action) => {
      state.auth = action.payload;
    },
    logout: (state, action) => {
      state.auth = {};
      state.userData = {};
      localStorage.removeItem("guestUserSessionKey");
    },
    clearPersistedState: (state, action) => {
      state.auth = {};
      state.userData = {};
      localStorage.removeItem("guestUserSessionKey");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLogin.fulfilled, (state, action) => {
      if(action?.payload?.data?.data.user_type === "B"){
        state.auth = action?.payload;
        localStorage.removeItem("guestUserSessionKey");
      } else {
        localStorage.removeItem("guestUserSessionKey");
        ToastNotifyError("This account is registered as a seller. Please log in as a seller");
      }
    });
    builder.addCase(fetchLogin.rejected, (state, action) => {
      state.auth = {
        error: true,
        errors: action.payload?.data || "An error occurred.",
      };
      ToastNotifyError(action.payload?.data?.message || "Login failed.");
    });
    builder.addCase(fetchLogout.fulfilled, (state, action) => {
      state.auth = {};
      state.userData = {};
      // localStorage.removeItem("guestUserSessionKey");
      ToastNotifySuccess(action?.payload?.data?.message);
    });
    builder.addCase(fetchLogout.rejected, (state, action) => {
      ToastNotifyError(action?.error?.message);
    });
    builder.addCase(fetchPostSignup.fulfilled, (state, action) => {
      state.auth = action?.payload;
      state.userData = action?.payload?.data;
      localStorage.removeItem("guestUserSessionKey");
    });
    builder.addCase(fetchPostSignup.rejected, (state, action) => {
      state.auth = {
        error: true,
        errors: action.payload?.data,
      };
      ToastNotifyError("Signup failed. Please try again.");
    });
    builder.addCase(fetchSocialLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSocialLogin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.auth = action?.payload;
      localStorage.removeItem("guestUserSessionKey");
    });
    builder.addCase(fetchSocialLogin.rejected, (state, action) => {
      state.isLoading = false;
      state.auth = {
        error: true,
        errors: action.payload?.data,
      };
      ToastNotifyError("Login failed. Please try again.");
    });
    builder.addCase(fetchGuestUserFlow.fulfilled, (_, action) => {
      if (action?.payload?.data) {
        const sessionKey = action.payload.data.session_key;
        if (sessionKey) {
          localStorage.setItem("guestUserSessionKey", sessionKey);
        }
      }
    });
    builder.addCase(fetchGuestUserFlow.rejected, (_, action) => {
      ToastNotifyError(
        action.payload?.data?.message || "Failed to fetch guest user flow."
      );
    });
  },
});

const {
  actions: { updateUserData, updateLogin, logout, clearPersistedState },
  reducer,
} = authenticationSlice;
const selectorAuthentication = (state) => state.authentication;

export { updateUserData, updateLogin, logout, clearPersistedState, selectorAuthentication };

export default reducer;
